import Time from '@/functions/Time'

export const calcDiff = (start: string, end: string, forExcel = true): string => {
  return Time.durationTime(start, end, forExcel ? 'mm' : 'd[Days] HH[h]mm[m]')
}
